/**
 * @flow
 * @relayHash 371fe374afc86d2fe30bdfbbec99389b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type rescheduleHyeventInput = {|
  clientMutationId?: ?string,
  id: string,
  startAt: string,
  endAt: string,
  publishDate: string,
  displayTime?: ?string,
|};
export type rescheduleEventMutationVariables = {|
  input: rescheduleHyeventInput
|};
export type rescheduleEventMutationResponse = {|
  +rescheduleHyevent: ?{|
    +clientMutationId: ?string,
    +hyevent: ?{|
      +id: string
    |},
  |}
|};
export type rescheduleEventMutation = {|
  variables: rescheduleEventMutationVariables,
  response: rescheduleEventMutationResponse,
|};
*/


/*
mutation rescheduleEventMutation(
  $input: rescheduleHyeventInput!
) {
  rescheduleHyevent(input: $input) {
    clientMutationId
    hyevent {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "rescheduleHyeventInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "rescheduleHyevent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "rescheduleHyeventPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyevent",
        "storageKey": null,
        "args": null,
        "concreteType": "Hyevent",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "rescheduleEventMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "rescheduleEventMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "rescheduleEventMutation",
    "id": null,
    "text": "mutation rescheduleEventMutation(\n  $input: rescheduleHyeventInput!\n) {\n  rescheduleHyevent(input: $input) {\n    clientMutationId\n    hyevent {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '665526609a9c14c6f63c92bc712aa50d';
module.exports = node;
